import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  justify-content: flex-end;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  color: ", ";\n  right: 0;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 8px 12px 6px;\n  box-sizing: border-box;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  overflow: hidden;\n  border-radius: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 0;\n  z-index: -1;\n  overflow: hidden;\n  visibility: hidden;\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  flex-wrap: wrap;\n  width: 100%;\n  ", "\n  ", "\n  ", "\n  & > input {\n    ", "\n    ", "\n    ", "\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  ", "\n  svg {\n    fill: ", ";\n  }\n  &:hover,\n  &:active {\n    svg {\n      fill: ", ";\n    }\n  }\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-right: 8px;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: flex;\n  align-items: center;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import Select, { components } from 'react-select';
import VirtualList, { ScrollAlignment, ScrollDirection } from 'react-small-virtual-list';
import styles from './styles';
import { ADVENTURE_GREEN_FOCUSED, ELEMENT_GRAY, INACTIVE_GRAY, NIGHTINGALE_BLACK, SENSATION_WHITE } from '../../colors';
import { SHADOW_FOCUSED } from '../../shadows';
import CloseIcon from '@tourlane/iconography/Glyphs/Navigation/Close';
import DownIcon from '@tourlane/iconography/Glyphs/Navigation/DropdownDown';
import SvgIcon, { Icon } from '../../SvgIcon';
import { CARD_BORDER_RADIUS_SMALL, ICON_SIZE } from '../../constants';
import FormLabel from '../../Form/FormLabel';
import { Small } from '../../Typography';
import AppearTransition from '../../Transitions/AppearTransition';
import DropdownOption from './DropdownOption';
import { EMPTY_ARRAY, EMPTY_PROPS, equalArrays, filterProps, getPx, prevent, refContainsTarget, setRef, zIndexValue } from '../../helpers';
import Hr from '../../Hr';
import { useDidUpdateEffect, useInOut, useInOutWithInput, useMediaBreakpoints, useWindowEventListener } from '../../hooks';
import { DROPDOWN_MENU_MIN_WIDTH, DROPDOWN_MENU_OPTIONS_MAX_DEFAULT_COUNT, DROPDOWN_MENU_OPTIONS_MAX_VISIBLE_COUNT, DROPDOWN_MENU_OPTIONS_MIN_DEFAULT_COUNT, DROPDOWN_MENU_OPTIONS_MIN_VISIBLE_COUNT, DROPDOWN_MULTI_HEIGHT, DROPDOWN_MULTI_VALUE_HEIGHT, DROPDOWN_MULTI_VALUE_ICON_SIZE, DROPDOWN_MULTI_VALUE_RIGHT_MARGIN, DROPDOWN_MULTI_VERTICAL_PADDING, DROPDOWN_OPTION_HEIGHT } from './constants';
import { INPUT_HEIGHT, INPUT_HORIZONTAL_PADDING, INPUT_ICON_LEFT_PADDING, INPUT_TEXT_WITH_ICON_LEFT_PADDING } from '../constants';
import { Input as InputSize } from '../../Typography/constants/input.size';
import { baseTextStyle } from '../../Typography/style/base';
import { overflowStyle } from '../../tokens/overflow';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { pointerEventsNoneStyle } from '../../tokens/pointer-events';
import { baseEllipsisStyle } from '../../tokens/ellipsis';
import { baseHighlightStyle } from '../../tokens/highlight';
import { baseSelectionStyle } from '../../tokens/selection';
import { getIconColor, getIconHoverColor, getInputButtonColor } from '../../helpers/icons';
import { fontSize, height, left, lineHeight, minWidth, paddingLeft, paddingRight, paddingVertical, size } from '../../style';
import DropdownIndicatorIcon from './DropdownIndicatorIcon';
var StyledValueIcon = styled(SvgIcon)(_templateObject(), height(INPUT_HEIGHT), paddingLeft(INPUT_ICON_LEFT_PADDING));
var StyledAdditionalIndicator = styled(SvgIcon)(_templateObject2(), height(INPUT_HEIGHT), function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled && 'pointer-events: none';
});
var StyledMultiValueContainer = styled.div(_templateObject3(), height(DROPDOWN_MULTI_HEIGHT), paddingRight(DROPDOWN_MULTI_VALUE_RIGHT_MARGIN));
var StyledMultiValueRemoveContainer = styled.div(_templateObject4(), size(DROPDOWN_MULTI_VALUE_HEIGHT), ELEMENT_GRAY, ADVENTURE_GREEN_FOCUSED, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && "\n      pointer-events: none\n    ";
});
var StyledValueWrapper = styled.div(_templateObject5(), baseHighlightStyle, function (_ref3) {
  var icon = _ref3.icon;
  return icon ? paddingLeft(INPUT_TEXT_WITH_ICON_LEFT_PADDING) : paddingLeft(INPUT_HORIZONTAL_PADDING);
}, paddingVertical(DROPDOWN_MULTI_VERTICAL_PADDING), fontSize(InputSize.fontSize), height(DROPDOWN_MULTI_HEIGHT), lineHeight(DROPDOWN_MULTI_HEIGHT));
var StyledInputHiddenContainer = styled.div(_templateObject6(), height(DROPDOWN_MULTI_HEIGHT), lineHeight(DROPDOWN_MULTI_HEIGHT), pointerEventsNoneStyle, userSelectNoneStyle);

var filterDataProps = function filterDataProps(props) {
  return filterProps(props, function (key) {
    return key.startsWith('data-');
  });
};

var Control = function Control(props) {
  return /*#__PURE__*/React.createElement(components.Control, _extends({}, props, {
    innerProps: _objectSpread(_objectSpread({}, props.innerProps), filterDataProps(props.selectProps))
  }));
};

var MultiValueContainer = function MultiValueContainer(props) {
  var _props$data;

  return ((_props$data = props.data) == null ? void 0 : _props$data.display) !== false ? /*#__PURE__*/React.createElement(StyledMultiValueContainer, null, /*#__PURE__*/React.createElement(components.MultiValueContainer, props)) : null;
};

var _ref4 = /*#__PURE__*/React.createElement(Icon, {
  as: CloseIcon,
  size: DROPDOWN_MULTI_VALUE_ICON_SIZE
});

var MultiValueRemove = function MultiValueRemove(props) {
  var isDisabled = props.selectProps.isDisabled;
  return /*#__PURE__*/React.createElement(StyledMultiValueRemoveContainer, {
    disabled: isDisabled
  }, /*#__PURE__*/React.createElement(components.MultiValueRemove, props, _ref4));
};

var Placeholder = function Placeholder(props) {
  var shrinkPlaceholder = props.selectProps.shrinkPlaceholder;
  return !shrinkPlaceholder ? /*#__PURE__*/React.createElement(components.Placeholder, props) : null;
}; // Copied from: https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/Select.js#L1457


var renderPlaceholderOrValue = function renderPlaceholderOrValue(select) {
  var _select$components = select.components,
      SingleValue = _select$components.SingleValue,
      Placeholder = _select$components.Placeholder;
  var commonProps = select.commonProps;
  var _select$props = select.props,
      controlShouldRenderValue = _select$props.controlShouldRenderValue,
      isDisabled = _select$props.isDisabled,
      inputValue = _select$props.inputValue,
      placeholder = _select$props.placeholder;
  var _select$state = select.state,
      selectValue = _select$state.selectValue,
      isFocused = _select$state.isFocused;

  if (!select.hasValue() || !controlShouldRenderValue) {
    return inputValue ? null : /*#__PURE__*/React.createElement(Placeholder, _extends({}, commonProps, {
      key: "placeholder",
      isDisabled: isDisabled,
      isFocused: isFocused
    }), placeholder);
  }

  var singleValue = selectValue[0];
  return /*#__PURE__*/React.createElement(SingleValue, _extends({}, commonProps, {
    data: singleValue,
    isDisabled: isDisabled
  }), select.formatOptionLabel(singleValue, 'value'));
}; // According to: https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/Select.js#L1842


var ValueContainerWithHiddenInput = function ValueContainerWithHiddenInput(_ref5) {
  var select = _ref5.select;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderPlaceholderOrValue(select), /*#__PURE__*/React.createElement(StyledInputHiddenContainer, null, select.renderInput()));
};

var ValueContainer = function ValueContainer(_ref6) {
  var children = _ref6.children,
      props = _objectWithoutPropertiesLoose(_ref6, ["children"]);

  var _props$selectProps = props.selectProps,
      icon = _props$selectProps.icon,
      error = _props$selectProps.error,
      isFocused = _props$selectProps.isFocused,
      isMulti = _props$selectProps.isMulti,
      shrinkPlaceholder = _props$selectProps.shrinkPlaceholder,
      placeholder = _props$selectProps.placeholder,
      selectRef = _props$selectProps.selectRef,
      hideErrorOnFocus = _props$selectProps.hideErrorOnFocus,
      hideInputProp = _props$selectProps.hideInput,
      isDisabled = props.isDisabled,
      hasValue = props.hasValue;
  var hideInput = hideInputProp && !isMulti && (selectRef == null ? void 0 : selectRef.select);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(components.ValueContainer, props, icon && !!children && /*#__PURE__*/React.createElement(StyledValueIcon, {
    color: getInputButtonColor(isFocused, isDisabled, error, !hideErrorOnFocus),
    size: ICON_SIZE
  }, icon), /*#__PURE__*/React.createElement(StyledValueWrapper, {
    icon: icon,
    multiple: isMulti
  }, !hideInput ? children : /*#__PURE__*/React.createElement(ValueContainerWithHiddenInput, {
    select: selectRef.select
  }, children))), shrinkPlaceholder && placeholder && /*#__PURE__*/React.createElement(FormLabel, {
    withIcon: !!icon,
    withRightIcon: true,
    shrink: isFocused || hasValue,
    focused: isFocused,
    disabled: isDisabled,
    error: !!error,
    placeholder: placeholder
  }));
};

var _ref7 = /*#__PURE__*/React.createElement(CloseIcon, null);

var ClearIndicator = function ClearIndicator(props) {
  var isDisabled = props.isDisabled,
      hasValue = props.hasValue,
      clearValue = props.clearValue,
      _props$selectProps2 = props.selectProps,
      blurOnClear = _props$selectProps2.blurOnClear,
      isMulti = _props$selectProps2.isMulti,
      menuIsOpen = _props$selectProps2.menuIsOpen,
      isClearable = _props$selectProps2.isClearable,
      hideClearIndicator = _props$selectProps2.hideClearIndicator,
      selectRef = _props$selectProps2.selectRef;
  var isShown = !isMulti && !menuIsOpen && hasValue && isClearable;
  var innerProps = blurOnClear ? {
    onMouseDown: function onMouseDown(e) {
      prevent(e);
      clearValue == null ? void 0 : clearValue(e);
      selectRef == null ? void 0 : selectRef.blur();
    },
    onTouchEnd: function onTouchEnd(e) {
      prevent(e);
      clearValue == null ? void 0 : clearValue(e);
      selectRef == null ? void 0 : selectRef.blur();
    }
  } : {};
  return isShown && !hideClearIndicator && /*#__PURE__*/React.createElement(components.ClearIndicator, _objectSpread(_objectSpread({}, props), {}, {
    innerProps: _objectSpread(_objectSpread({}, props.innerProps), innerProps)
  }), /*#__PURE__*/React.createElement(DropdownIndicatorIcon, {
    isDisabled: isDisabled,
    icon: _ref7
  }));
};

var _ref8 = /*#__PURE__*/React.createElement(DownIcon, null);

var DropdownIndicator = function DropdownIndicator(props) {
  var isDisabled = props.isDisabled,
      hasValue = props.hasValue,
      _props$selectProps3 = props.selectProps,
      isMulti = _props$selectProps3.isMulti,
      menuIsOpen = _props$selectProps3.menuIsOpen,
      isClearable = _props$selectProps3.isClearable,
      hideDropdownIndicator = _props$selectProps3.hideDropdownIndicator,
      iconRight = _props$selectProps3.iconRight;
  var isShown = isMulti || menuIsOpen || !(hasValue && isClearable);
  return isShown && !hideDropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(DropdownIndicatorIcon, {
    isDisabled: isDisabled,
    isRotated: !iconRight && menuIsOpen,
    icon: iconRight || _ref8
  }));
};

var Option = function Option(_ref9) {
  var _data$icon, _data$image;

  var innerRef = _ref9.innerRef,
      innerProps = _ref9.innerProps,
      data = _ref9.data,
      isSelected = _ref9.isSelected,
      isDisabled = _ref9.isDisabled,
      isFocused = _ref9.isFocused,
      _ref9$selectProps = _ref9.selectProps,
      renderOptionIcon = _ref9$selectProps.renderOptionIcon,
      renderOptionImage = _ref9$selectProps.renderOptionImage;
  var icon = renderOptionIcon == null ? void 0 : renderOptionIcon(data);
  var image = renderOptionImage == null ? void 0 : renderOptionImage(data);
  var option = icon || image ? _objectSpread(_objectSpread({}, data), {}, {
    icon: (_data$icon = data.icon) != null ? _data$icon : icon,
    image: (_data$image = data.image) != null ? _data$image : image
  }) : data;
  return /*#__PURE__*/React.createElement(DropdownOption, _extends({
    ref: innerRef,
    noHover: true,
    option: option,
    selected: isSelected,
    disabled: isDisabled,
    focused: isFocused
  }, innerProps));
};

var StyledMenu = styled.div(_templateObject7(), function (_ref10) {
  var $minWidth = _ref10.$minWidth;
  return minWidth($minWidth);
}, overflowStyle, getPx(CARD_BORDER_RADIUS_SMALL), SENSATION_WHITE, SHADOW_FOCUSED);

var Menu = function Menu(_ref11) {
  var innerRef = _ref11.innerRef,
      props = _objectWithoutPropertiesLoose(_ref11, ["innerRef"]);

  var _props$selectProps4 = props.selectProps,
      minMenuWidth = _props$selectProps4.minMenuWidth,
      menuRef = _props$selectProps4.menuRef;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(components.Menu, props, /*#__PURE__*/React.createElement(AppearTransition, {
    ref: menuRef,
    show: true,
    placement: props.placement
  }, /*#__PURE__*/React.createElement(StyledMenu, {
    ref: innerRef,
    $minWidth: minMenuWidth
  }, props.children))));
};

var Group = function Group(_ref12) {
  var children = _ref12.children,
      cx = _ref12.cx,
      getStyles = _ref12.getStyles,
      Heading = _ref12.Heading,
      headingProps = _ref12.headingProps,
      label = _ref12.label,
      theme = _ref12.theme,
      selectProps = _ref12.selectProps;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), children);
};

var StyledGroupHeading = styled(Small)(_templateObject8(), height(DROPDOWN_OPTION_HEIGHT), userSelectNoneStyle, pointerEventsNoneStyle);

var GroupHeading = function GroupHeading(_ref13) {
  var children = _ref13.children;
  return children ? /*#__PURE__*/React.createElement(StyledGroupHeading, {
    ellipsis: true,
    muted: true,
    as: "div"
  }, children) : null;
};

var getOptions = function getOptions(children) {
  return (
    /* @ts-expect-error Wrong types casting */
    React.Children.toArray(children).reduce(function (acc, option) {
      var _option$props, _option$props$data;

      if ((_option$props = option.props) != null && (_option$props$data = _option$props.data) != null && _option$props$data.options) {
        var _option$props2, _option$props3, _option$props3$headin, _option$props4;

        var options = React.Children.toArray((_option$props2 = option.props) == null ? void 0 : _option$props2.children);
        var key = (_option$props3 = option.props) == null ? void 0 : (_option$props3$headin = _option$props3.headingProps) == null ? void 0 : _option$props3$headin.id;
        var label = (_option$props4 = option.props) == null ? void 0 : _option$props4.label;
        return label ? acc.concat([/*#__PURE__*/React.createElement(GroupHeading, {
          key: key
        }, label)], options) : acc.concat(option);
      }

      return acc.concat(option);
    }, [])
  );
};

var flattenValue = function flattenValue(value) {
  return (value || []).map(function (v) {
    return v.value;
  });
};

var flattenOptions = function flattenOptions(options) {
  return options.reduce(function (acc, option) {
    return option.options ? acc.concat(option.options) : acc.concat(option);
  }, []);
};

var flattenOptionsChildren = function flattenOptionsChildren(children) {
  return React.Children.toArray(children).reduce(function (acc, option) {
    var _option$props5, _option$props5$data, _option$props8;

    if ((_option$props5 = option.props) != null && (_option$props5$data = _option$props5.data) != null && _option$props5$data.options) {
      var _option$props6;

      var options = React.Children.toArray((_option$props6 = option.props) == null ? void 0 : _option$props6.children);
      return acc.concat(options.map(function (option) {
        var _option$props7;

        return (_option$props7 = option.props) == null ? void 0 : _option$props7.data;
      }));
    }

    return acc.concat((_option$props8 = option.props) == null ? void 0 : _option$props8.data);
  }, [])
  /* @ts-expect-error Wrong types casting */
  .filter(Boolean);
};

var VirtualizedMenuList = function VirtualizedMenuList(_ref14) {
  var _ref14$selectProps = _ref14.selectProps,
      selectRef = _ref14$selectProps.selectRef,
      hasGroups = _ref14$selectProps.hasGroups,
      maxHeight = _ref14$selectProps.maxHeight,
      optionHeight = _ref14$selectProps.optionHeight,
      children = _ref14.children;
  var focusedOption = selectRef.select.state.focusedOption;
  /* @ts-expect-error Types mismatch */

  var options = useMemo(function () {
    return hasGroups ? getOptions(children) : React.Children.toArray(children);
  }, [children, hasGroups]);

  var _useState = useState({}),
      heights = _useState[0],
      setHeights = _useState[1];

  var _useState2 = useState(optionHeight * options.length),
      optionsMaxHeight = _useState2[0],
      setOptionsMaxHeight = _useState2[1];

  var _useState3 = useState(0),
      optionsMaxFilteredHeight = _useState3[0],
      setOptionsMaxFilteredHeight = _useState3[1];

  var _useState4 = useState(false),
      hasExtraHeight = _useState4[0],
      setHasExtraHeight = _useState4[1];

  var getOptionHeight = useCallback(function (index) {
    return heights[index] || optionHeight;
  }, [heights, optionHeight, options.length]);
  var measureOptionRef = useCallback(function (ref, index) {
    if (!ref) {
      return;
    }

    var newHeight = ref.offsetHeight;

    if (newHeight === optionHeight && !heights[index] || heights[index] === newHeight) {
      return;
    } // Calculate extra height to sum-up with max options height


    var heightExtra = newHeight - (heights[index] || optionHeight);

    if (heightExtra !== 0) {
      setOptionsMaxHeight(function (v) {
        return v + heightExtra;
      });
      setHasExtraHeight(true);
    } // Save new height to the map


    setHeights(function (heights) {
      var _objectSpread2;

      return _objectSpread(_objectSpread({}, heights), {}, (_objectSpread2 = {}, _objectSpread2[index] = newHeight, _objectSpread2));
    });
  }, [heights, optionHeight]);
  useDidUpdateEffect(function () {
    if (options.length <= DROPDOWN_MENU_OPTIONS_MAX_VISIBLE_COUNT) {
      // calculate filtered height explicitly
      if (hasExtraHeight) {
        setOptionsMaxFilteredHeight(options.reduce(function (acc, item, index) {
          return acc + getOptionHeight(index);
        }, 0));
      } else {
        setOptionsMaxFilteredHeight(options.length * optionHeight);
      }
    } else {
      // just reset filtered height
      if (optionsMaxFilteredHeight !== 0) {
        setOptionsMaxFilteredHeight(0);
      }
    }
  }, [options.length]);
  var scrollHeight = useMemo(function () {
    return Math.min(maxHeight, optionsMaxFilteredHeight || optionsMaxHeight);
  }, [maxHeight, optionsMaxFilteredHeight, optionsMaxHeight]);
  var focusedIndex = useMemo(function () {
    var index = options.findIndex(function (item) {
      var _item$props, _item$props2;

      return ((_item$props = item.props) == null ? void 0 : _item$props.isFocused) || ((_item$props2 = item.props) == null ? void 0 : _item$props2.data) === focusedOption;
    });
    return index >= 0 ? index : 0;
  }, [options, focusedOption]);
  var handleRenderItem = useCallback(function (_ref15) {
    var _options$index;

    var index = _ref15.index,
        style = _ref15.style;
    return /*#__PURE__*/React.createElement("div", {
      style: style,
      key: "item-" + index + "-" + ((_options$index = options[index]) == null ? void 0 : _options$index.key)
    }, /*#__PURE__*/React.createElement("div", {
      ref: function ref(_ref16) {
        return measureOptionRef(_ref16, index);
      }
    }, options[index]));
  }, [measureOptionRef, options]);
  return /*#__PURE__*/React.createElement(VirtualList, {
    width: "100%",
    height: scrollHeight,
    itemCount: options.length,
    itemSize: getOptionHeight,
    estimatedItemSize: optionHeight,
    scrollDirection: ScrollDirection.VERTICAL,
    scrollToIndex: focusedIndex,
    overscanCount: 4,
    scrollToAlignment: ScrollAlignment.SMART,
    renderItem: handleRenderItem
  });
};

var _ref17 = /*#__PURE__*/React.createElement(Hr, null);

var MenuListWithToggleAll = function MenuListWithToggleAll(props) {
  var _props$selectProps5 = props.selectProps,
      value = _props$selectProps5.value,
      options = _props$selectProps5.options,
      toggleAllTitle = _props$selectProps5.toggleAllTitle,
      setValue = props.setValue,
      clearValue = props.clearValue,
      children = props.children;
  var optionsValues = useMemo(function () {
    return flattenOptions(options).map(function (o) {
      return o.value;
    });
  }, [options]);
  var optionsChildrenValues = useMemo(function () {
    return flattenOptionsChildren(children).map(function (o) {
      return o.value;
    });
  }, [children]);
  var selectedValues = useMemo(function () {
    return flattenValue(value);
  }, [value]);
  var isInitial = useMemo(function () {
    return equalArrays(optionsValues, optionsChildrenValues, false, true);
  }, [optionsValues, optionsChildrenValues]);
  var isSelected = useMemo(function () {
    return equalArrays(optionsValues, selectedValues, false, true);
  }, [optionsValues, selectedValues]);
  var handleToggleAllClick = useCallback(function () {
    if (isSelected) {
      clearValue == null ? void 0 : clearValue();
    } else {
      setValue == null ? void 0 : setValue(options);
    }
  }, [isSelected, setValue, clearValue]);

  if (isInitial) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownOption, {
      onClick: handleToggleAllClick,
      option: {
        label: toggleAllTitle,
        toggle: true
      },
      selected: isSelected
    }), _ref17, /*#__PURE__*/React.createElement(MenuListDefault, props));
  }

  return /*#__PURE__*/React.createElement(MenuListDefault, props);
};

var MenuListDefault = function MenuListDefault(props) {
  var useVirtualizedMenuList = props.selectProps.useVirtualizedMenuList;

  if (!useVirtualizedMenuList) {
    // fallback to default menu list
    return /*#__PURE__*/React.createElement(components.MenuList, _extends({}, props, {
      theme: {
        spacing: {
          baseUnit: 0
        },
        borderRadius: 4
      }
    }));
  }

  return /*#__PURE__*/React.createElement(VirtualizedMenuList, props);
};

var MenuList = function MenuList(props) {
  var _props$selectProps6 = props.selectProps,
      isMulti = _props$selectProps6.isMulti,
      hideSelectedOptions = _props$selectProps6.hideSelectedOptions,
      withToggleAll = _props$selectProps6.withToggleAll;

  if (isMulti && withToggleAll && !hideSelectedOptions) {
    return /*#__PURE__*/React.createElement(MenuListWithToggleAll, props);
  }

  return /*#__PURE__*/React.createElement(MenuListDefault, props);
};

var SingleValueWrapper = styled.div(_templateObject9(), function (_ref18) {
  var isDisabled = _ref18.isDisabled;
  return isDisabled ? INACTIVE_GRAY : NIGHTINGALE_BLACK;
}, function (_ref19) {
  var icon = _ref19.icon;
  return icon ? left(INPUT_TEXT_WITH_ICON_LEFT_PADDING) : left(INPUT_HORIZONTAL_PADDING);
}, baseTextStyle, baseSelectionStyle, baseHighlightStyle, userSelectNoneStyle, baseEllipsisStyle, fontSize(InputSize.fontSize), height(DROPDOWN_MULTI_HEIGHT), lineHeight(DROPDOWN_MULTI_HEIGHT));

var SingleValue = function SingleValue(_ref20) {
  var children = _ref20.children,
      isDisabled = _ref20.isDisabled,
      props = _objectWithoutPropertiesLoose(_ref20, ["children", "isDisabled"]);

  var icon = props.selectProps.icon;
  return /*#__PURE__*/React.createElement(SingleValueWrapper, {
    isDisabled: isDisabled,
    icon: icon
  }, children);
};

var IndicatorsContainerWrapper = styled.div(_templateObject10(), function (_ref21) {
  var fullSize = _ref21.fullSize;
  return fullSize ? paddingLeft(8) : '';
}, function (_ref22) {
  var fullSize = _ref22.fullSize;
  return fullSize ? minWidth(INPUT_TEXT_WITH_ICON_LEFT_PADDING) : minWidth(INPUT_HORIZONTAL_PADDING);
}, height(INPUT_HEIGHT));

var IndicatorsContainer = function IndicatorsContainer(_ref23) {
  var _additionalIndicatorP;

  var children = _ref23.children,
      props = _objectWithoutPropertiesLoose(_ref23, ["children"]);

  var hasValue = props.hasValue,
      _props$selectProps7 = props.selectProps,
      isMulti = _props$selectProps7.isMulti,
      menuIsOpen = _props$selectProps7.menuIsOpen,
      isClearable = _props$selectProps7.isClearable,
      hideDropdownIndicator = _props$selectProps7.hideDropdownIndicator,
      hideClearIndicator = _props$selectProps7.hideClearIndicator,
      isDisabled = _props$selectProps7.isDisabled,
      additionalIndicator = _props$selectProps7.additionalIndicator,
      additionalIndicatorProps = _props$selectProps7.additionalIndicatorProps;
  var isShownDropdown = (isMulti || menuIsOpen || !(hasValue && isClearable)) && !hideDropdownIndicator;
  var isShownClear = !isMulti && !menuIsOpen && hasValue && isClearable && !hideClearIndicator;
  var isShownAdditionalIndicator = additionalIndicator && hasValue;
  var isAdditionalIndicatorDisabled = (_additionalIndicatorP = additionalIndicatorProps == null ? void 0 : additionalIndicatorProps.isDisabled) != null ? _additionalIndicatorP : isDisabled;
  return /*#__PURE__*/React.createElement(IndicatorsContainerWrapper, {
    fullSize: isShownDropdown || isShownClear || isShownAdditionalIndicator
  }, isShownAdditionalIndicator && /*#__PURE__*/React.createElement(StyledAdditionalIndicator, _extends({
    color: getIconColor(isAdditionalIndicatorDisabled),
    colorHover: getIconHoverColor(isAdditionalIndicatorDisabled),
    size: ICON_SIZE,
    onMouseDown: prevent,
    onTouchEnd: prevent,
    isDisabled: isDisabled
  }, additionalIndicatorProps), additionalIndicator), children);
};

// basically, that's a styled react-select component
var DropdownSimpleSelect = /*#__PURE__*/React.forwardRef(function (_ref24, forwardedRef) {
  var _props$value;

  var _ref24$menuPlacement = _ref24.menuPlacement,
      menuPlacement = _ref24$menuPlacement === void 0 ? 'auto' : _ref24$menuPlacement,
      _ref24$useVirtualized = _ref24.useVirtualizedMenuList,
      useVirtualizedMenuList = _ref24$useVirtualized === void 0 ? false : _ref24$useVirtualized,
      _ref24$hideErrorOnFoc = _ref24.hideErrorOnFocus,
      hideErrorOnFocus = _ref24$hideErrorOnFoc === void 0 ? true : _ref24$hideErrorOnFoc,
      _ref24$hideInput = _ref24.hideInput,
      hideInput = _ref24$hideInput === void 0 ? false : _ref24$hideInput,
      _ref24$blurOnClear = _ref24.blurOnClear,
      blurOnClear = _ref24$blurOnClear === void 0 ? true : _ref24$blurOnClear,
      component = _ref24.component,
      _ref24$icon = _ref24.icon,
      icon = _ref24$icon === void 0 ? null : _ref24$icon,
      _ref24$menuZIndex = _ref24.menuZIndex,
      menuZIndex = _ref24$menuZIndex === void 0 ? zIndexValue('menu') : _ref24$menuZIndex,
      parentQuerySelector = _ref24.parentQuerySelector,
      error = _ref24.error,
      onBlur = _ref24.onBlur,
      onFocus = _ref24.onFocus,
      onMenuOpenProp = _ref24.onMenuOpen,
      onMenuCloseProp = _ref24.onMenuClose,
      menuIsOpenProp = _ref24.menuIsOpen,
      _ref24$defaultMenuIsO = _ref24.defaultMenuIsOpen,
      defaultMenuIsOpen = _ref24$defaultMenuIsO === void 0 ? false : _ref24$defaultMenuIsO,
      _ref24$options = _ref24.options,
      options = _ref24$options === void 0 ? EMPTY_ARRAY : _ref24$options,
      _ref24$components = _ref24.components,
      components = _ref24$components === void 0 ? EMPTY_PROPS : _ref24$components,
      renderOptionIcon = _ref24.renderOptionIcon,
      renderOptionImage = _ref24.renderOptionImage,
      minMenuHeightProp = _ref24.minMenuHeight,
      maxMenuHeightProp = _ref24.maxMenuHeight,
      maxHeightProp = _ref24.maxHeight,
      _ref24$minOptionsCoun = _ref24.minOptionsCount,
      minOptionsCountProp = _ref24$minOptionsCoun === void 0 ? DROPDOWN_MENU_OPTIONS_MIN_DEFAULT_COUNT : _ref24$minOptionsCoun,
      _ref24$maxOptionsCoun = _ref24.maxOptionsCount,
      maxOptionsCountProp = _ref24$maxOptionsCoun === void 0 ? DROPDOWN_MENU_OPTIONS_MAX_DEFAULT_COUNT : _ref24$maxOptionsCoun,
      _ref24$minMenuWidth = _ref24.minMenuWidth,
      minMenuWidth = _ref24$minMenuWidth === void 0 ? DROPDOWN_MENU_MIN_WIDTH : _ref24$minMenuWidth,
      _ref24$toggleAllTitle = _ref24.toggleAllTitle,
      toggleAllTitle = _ref24$toggleAllTitle === void 0 ? 'Select all' : _ref24$toggleAllTitle,
      _ref24$withToggleAll = _ref24.withToggleAll,
      withToggleAll = _ref24$withToggleAll === void 0 ? false : _ref24$withToggleAll,
      props = _objectWithoutPropertiesLoose(_ref24, ["menuPlacement", "useVirtualizedMenuList", "hideErrorOnFocus", "hideInput", "blurOnClear", "component", "icon", "menuZIndex", "parentQuerySelector", "error", "onBlur", "onFocus", "onMenuOpen", "onMenuClose", "menuIsOpen", "defaultMenuIsOpen", "options", "components", "renderOptionIcon", "renderOptionImage", "minMenuHeight", "maxMenuHeight", "maxHeight", "minOptionsCount", "maxOptionsCount", "minMenuWidth", "toggleAllTitle", "withToggleAll"]);

  var isMulti = props.isMulti;
  var selectRef = useRef(null);

  var _useInOut = useInOut(onFocus, onBlur),
      isFocused = _useInOut[0],
      handleFocus = _useInOut[1],
      handleBlur = _useInOut[2];

  var hasGroups = useMemo(function () {
    return options.filter(function (o) {
      return o.options;
    }).length > 0;
  }, [options]);
  /* @ts-expect-error Select props mismatch */

  var SelectComponent = useMemo(function () {
    return component || Select;
  }, [component]);
  var optionHeight = useMediaBreakpoints(DROPDOWN_OPTION_HEIGHT);
  var minOptionsMediaCount = useMediaBreakpoints(minOptionsCountProp);
  var maxOptionsMediaCount = useMediaBreakpoints(maxOptionsCountProp);
  var minOptionsCount = useMemo(function () {
    return Math.max(minOptionsMediaCount, DROPDOWN_MENU_OPTIONS_MIN_VISIBLE_COUNT);
  }, [minOptionsMediaCount]);
  var maxOptionsCount = useMemo(function () {
    return Math.min(maxOptionsMediaCount, DROPDOWN_MENU_OPTIONS_MAX_VISIBLE_COUNT);
  }, [maxOptionsMediaCount]);
  var minMenuHeight = useMediaBreakpoints(minMenuHeightProp);
  var maxMenuHeight = useMediaBreakpoints(maxMenuHeightProp);
  var maxHeight = useMediaBreakpoints(maxHeightProp);
  var displayedMaxHeight = useMemo(function () {
    return maxHeight != null ? maxHeight : optionHeight * maxOptionsCount;
  }, [maxHeight, optionHeight, maxOptionsCount]);
  var displayedMaxMenuHeight = useMemo(function () {
    return maxMenuHeight != null ? maxMenuHeight : displayedMaxHeight;
  }, [maxMenuHeight, displayedMaxHeight]);
  var displayedMinMenuHeight = useMemo(function () {
    return minMenuHeight != null ? minMenuHeight : optionHeight * minOptionsCount;
  }, [minMenuHeight, optionHeight, minOptionsCount]);
  var menuRef = useRef(null); // Feature of focusing selected option when menu is getting opened

  var onMenuOpen = useCallback(function () {
    onMenuOpenProp == null ? void 0 : onMenuOpenProp();

    if (!isMulti) {
      var _selectRef$current, _selectRef$current$se, _selectRef$current$se2, _selectRef$current$se3;

      // Getting a selected option
      var _option = (_selectRef$current = selectRef.current) == null ? void 0 : (_selectRef$current$se = _selectRef$current.select) == null ? void 0 : (_selectRef$current$se2 = _selectRef$current$se.state) == null ? void 0 : (_selectRef$current$se3 = _selectRef$current$se2.selectValue) == null ? void 0 : _selectRef$current$se3[0];

      if (_option) {
        setTimeout(function () {
          var _selectRef$current2;

          // Setting a focused value as a selected one
          // References:
          // - https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/Select.js#L503
          // - https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/Select.js#L802
          if ((_selectRef$current2 = selectRef.current) != null && _selectRef$current2.select) {
            var selectedIndex = selectRef.current.select.state.menuOptions.focusable.indexOf(_option);

            if (selectedIndex >= 0) {
              // Focusing selected option only if it exists
              selectRef.current.select.scrollToFocusedOptionOnUpdate = true;
              selectRef.current.select.inputIsHiddenAfterUpdate = false;
              selectRef.current.select.setState({
                focusedValue: null,
                focusedOption: _option
              });
            }
          }
        });
      }
    }
  }, [onMenuOpenProp, isMulti]);

  var _useInOutWithInput = useInOutWithInput(menuIsOpenProp, defaultMenuIsOpen, onMenuOpen, onMenuCloseProp),
      menuIsOpen = _useInOutWithInput[0],
      handleMenuOpen = _useInOutWithInput[1],
      handleMenuClose = _useInOutWithInput[2];

  useWindowEventListener('scroll', function (e) {
    if (!refContainsTarget(menuRef, e.target)) {
      handleMenuClose();
    }
  }, !parentQuerySelector, true);
  useWindowEventListener('resize', function () {
    handleMenuClose();
  }, !parentQuerySelector);
  return /*#__PURE__*/React.createElement(SelectComponent, _extends({
    ref: function ref(_ref25) {
      setRef(forwardedRef, _ref25);
      selectRef.current = _ref25;
    },
    hideInput: hideInput,
    useVirtualizedMenuList: useVirtualizedMenuList,
    blurOnClear: blurOnClear,
    components: _objectSpread({
      Placeholder: Placeholder,
      ValueContainer: ValueContainer,
      ClearIndicator: ClearIndicator,
      DropdownIndicator: DropdownIndicator,
      MultiValueContainer: MultiValueContainer,
      MultiValueRemove: MultiValueRemove,
      Option: Option,
      Menu: Menu,
      MenuList: MenuList,
      SingleValue: SingleValue,
      IndicatorsContainer: IndicatorsContainer,
      Control: Control,
      Group: Group,
      GroupHeading: GroupHeading
    }, components)
    /* @ts-expect-error `onFocus` prop mismatch */
    ,
    onFocus: handleFocus
    /* @ts-expect-error `onBlur` prop mismatch */
    ,
    onBlur: handleBlur,
    error: error,
    icon: icon
    /* @ts-expect-error `styles` prop mismatch */
    ,
    styles: styles(_objectSpread({
      icon: icon,
      error: error,
      menuZIndex: menuZIndex,
      hideErrorOnFocus: hideErrorOnFocus
    }, props)),
    isFocused: isFocused,
    menuPortalTarget: parentQuerySelector ? parentQuerySelector === 'body' ? document.body : document.querySelector(parentQuerySelector) : undefined,
    options: options,
    hasGroups: hasGroups,
    selectRef: selectRef.current,
    renderOptionIcon: renderOptionIcon,
    renderOptionImage: renderOptionImage,
    menuPlacement: menuPlacement,
    optionHeight: optionHeight,
    maxHeight: displayedMaxHeight,
    maxMenuHeight: displayedMaxMenuHeight,
    minMenuHeight: displayedMinMenuHeight,
    minMenuWidth: minMenuWidth,
    toggleAllTitle: toggleAllTitle,
    withToggleAll: withToggleAll
    /* @ts-expect-error `isDisabled` prop mismatch */
    ,
    isOptionDisabled: function isOptionDisabled(option) {
      return option.disabled || option.isDisabled;
    },
    menuRef: menuRef,
    menuIsOpen: menuIsOpen,
    onMenuOpen: handleMenuOpen,
    onMenuClose: handleMenuClose,
    hideErrorOnFocus: hideErrorOnFocus
  }, props, {
    // undefined doesn't reset Dropdown value, only null or an empty string
    value: (_props$value = props.value) != null ? _props$value : null
  }));
});
export default DropdownSimpleSelect;